import Service from "../../../Services/index";

const Bank = {
    namespaced: true,
    state: {
        bankTable: [],
        bank_all: [],
        form: {
            id: "",
            name: "",
            bank_name: "",
            bank_type_id: null,
            account_name: "",
            account_number: "",
            bank_branch: "",
            account_holder: '',
            phone: '',
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        //statement
        statement_data: {
            bank: null,
            dc: [],
        },
        //statement
        statement_month_data: {
            bank: null,
            dc: [],
        },
    },
    mutations: {
        SET_BANKS: (state, res) => {
            state.bankTable = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        },
        SET_BANK_BY_ID: (state, res) => {
            state.form = res;
        },
        SET_BANK_ALL: (state, res) => {
            state.bank_all = res;
        },
        CLEAR_DATA_FORM: state => {
            state.form = {
                id: "",
                name: "",
                bank_name: "",
                bank_type_id: null,
                account_name: "",
                account_number: "",
                bank_branch: "",
                account_holder: '',
                phone: '',
            }
        },

        //statement
        SET_STATEMENT: (state, res) => {
            state.statement_data = res;
        },
        //statement
        SET_STATEMENT_MONTH: (state, res) => {
            state.statement_month_data = res;
            state.statement_month_data.bank = res[0].bank
        },
    },
    actions: {
        setBank({commit}, page = 1) {
            return Service.Bank.getBank(page)
                .then(data => {
                    commit("SET_BANKS", data)
                })
        },
        getBankAll({commit}) {
            return Service.Bank.getBankAll()
                .then(data => {
                    commit("SET_BANK_ALL", data)
                })
        },
        showBank({commit}, id) {
            return Service.Bank.getBankById(id)
                .then(data => {
                    commit("SET_BANK_BY_ID", data)
                })
        },
        saveBank({commit}, {id, data}) {
            if (!id) {
                return Service.Bank.createBank(data).then(() => {
                    //console.log("create")
                });
            } else {
                return Service.Bank.updateBank(id, data).then(() => {
                    //console.log("update")
                });
            }
        },
        deleteBank({commit}, id) {
            return Service.Bank.deleteBank(id);
        },
        clearData({commit}) {
            commit("CLEAR_DATA_FORM");
        },

        //statement
        getStatement({commit}, {bank_id, start_date, end_date}) {
            return Service.Bank.getStatement(bank_id, start_date, end_date)
                .then(data => {
                    commit("SET_STATEMENT", data)
                })
        },
        getStatementMonth({commit}, {bank_id, start_date, end_date}) {
            return Service.Bank.getMonthStatement(bank_id, start_date, end_date)
                .then(data => {
                    commit("SET_STATEMENT_MONTH", data)
                })
        },
        //sum statement
        getSumStatement({commit}, {bank_id, start_date, end_date}) {
            return Service.Bank.getSumStatement(bank_id, start_date, end_date)
        },
        saveStatement({commit}, data) {
            return Service.Bank.saveStatement(data);
        },
        showStatement({commit}, id) {
            return Service.Bank.showStatement(id);
        },
        editStatement({commit}, {id, data}) {
            return Service.Bank.editStatement(id, data);
        },
        deleteStatement({commit}, id) {
            return Service.Bank.deleteStatement(id);
        },
        //branch bank
        getBranchBank({commit}, page) {
            return Service.Bank.getBankBranch(page);
        },
        showBranchBank({commit}, id) {
            return Service.Bank.showBankBranch(id);
        },
        saveBranchBank({commit}, {id, data}) {
            if (id) {
                return Service.Bank.updateBankBranch(id, data);
            } else {
                return Service.Bank.createBankBranch(data);
            }
        },
        deleteBankBranch({commit}, id) {
            return Service.Bank.deleteBankBranch(id);
        },
        searchBranchBank({commit}, {page, data}) {
            return Service.Bank.searchBankBranch(page, data);
        }
    }
};

export default Bank
